import * as url from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";

const api = new APIClient();

// Persons
export const getPersons = (params: any) => api.get(url.GET_PERSONS, params);
export const getPerson = (id: any, params: any) =>
  api.get(url.GET_PERSON + "/" + id, params);
export const addPerson = (data: any) => api.create(url.ADD_PERSON, data);
export const updatePerson = (data: any) =>
  api.update(url.UPDATE_PERSON + "/" + data.id, data);
export const deletePerson = (data: any) =>
  api.delete(url.DELETE_PERSON + "/" + data.id, data);

export const updatePersonSEMG = (data: any) =>
  api.update(
    url.UPDATE_PERSON_SEMG_MENTION + "/" + data.id + "/semg-mention",
    data
  );
export const importPerson = (
  data: any,
  accessToken: string,
  options?: { timeoutMs?: number }
) => {
  const controller = new AbortController();
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  if (options?.timeoutMs) {
    timeoutId = setTimeout(() => controller.abort(), options.timeoutMs);
  }

  return fetch(process.env.REACT_APP_API_URL + url.IMPORT_PERSON, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(data),
    signal: controller.signal,
  })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const metadata = response.headers.get("X-Metadata");
      let parsedMetadata = null;
      if (metadata) {
        try {
          parsedMetadata = JSON.parse(metadata);
        } catch (e) {
          parsedMetadata = metadata;
        }
      }

      const blob = await response.blob();
      return { blob, metadata: parsedMetadata };
    })
    .finally(() => {
      if (timeoutId !== null) clearTimeout(timeoutId);
    });
};
export const exportPersonsToCSV = (params: any) =>
  api.get(url.EXPORT_PERSONS_TO_CSV, params);

export const updatePersonAffiliationsToContractor = (data: any) =>
  api.update(
    url.UPDATE_PERSON_AFFILIATIONS_TO_CONTRACTOR +
      "/" +
      data.id +
      "/affiliations-to-contractors",
    data
  );
export const updatePersonAffiliationsToPerson = (data: any) =>
  api.update(
    url.UPDATE_PERSON_AFFILIATIONS_TO_PERSON +
      "/" +
      data.id +
      "/affiliations-to-persons",
    data
  );

// Classified Information
export const getClassifiedInformationTypes = () =>
  api.get(url.GET_CLASSIFIED_INFORMATION_TYPES);

export const updateClassifiedInformation = (id: any, data: any) =>
  api.update(
    url.UPDATE_CLASSIFIED_INFORMATION + "/" + id + "/classified-information",
    data
  );
